import LegalDocLayout, {
  LegalSection,
} from "@/components/LegalDocLayout";

export default function Privacy() {
  return (
    <LegalDocLayout
      testid="legal-doc-page-privacy"
      title="Privacy Policy"
      effectiveDate="[PLACEHOLDER — to be filled by legal counsel]"
      lastUpdated="[PLACEHOLDER]"
    >
      <LegalSection heading="1. Introduction">
        This Privacy Policy explains how FiguMatch (the
        &ldquo;Service&rdquo;) collects, uses, and shares information
        about you when you use our platform. We are committed to
        respecting your privacy and to being transparent about our data
        practices.
      </LegalSection>

      <LegalSection heading="2. Information We Collect">
        We collect information you provide directly, such as your email,
        display name, sticker inventory, and messages. We also collect
        information automatically, such as device identifiers, IP
        address, user-agent, approximate location (when you enable
        geolocation), and interaction logs used to improve the Service.
      </LegalSection>

      <LegalSection heading="3. How We Use Your Information">
        We use the information we collect to operate and improve the
        Service, match you with nearby collectors, deliver in-app
        rewards, respond to support requests, prevent fraud and abuse,
        and communicate updates. We may also use aggregated,
        de-identified information for research and product analytics.
      </LegalSection>

      <LegalSection heading="4. Data Sharing and Disclosure">
        We do not sell your personal information. We share limited
        information with service providers who help us operate the
        platform, and with other users only to the extent necessary for
        the Service to function (for example, your display name and
        approximate distance shown on the Radar). We may disclose
        information when required by law.
      </LegalSection>

      <LegalSection heading="5. Data Retention">
        We retain your personal information for as long as your account
        is active or as needed to provide the Service. When you delete
        your account, we remove or anonymize your personal information
        within a reasonable period, unless retention is required for
        legal, security, or audit purposes.
      </LegalSection>

      <LegalSection heading="6. Your Rights (GDPR / CCPA)">
        Depending on your jurisdiction, you may have the right to
        access, correct, delete, or export your personal information, to
        object to certain processing, and to withdraw consent where
        processing is based on consent. You may exercise these rights by
        contacting us at hello@figumatch.com.
      </LegalSection>

      <LegalSection heading="7. Cookies and Tracking Technologies">
        We use cookies and similar technologies to keep you signed in,
        remember preferences, measure feature usage, and improve
        performance. You can control cookies through your browser
        settings, but disabling them may affect Service functionality.
      </LegalSection>

      <LegalSection heading="8. Third-Party Services">
        The Service integrates with third-party providers for essential
        functionality, including AI conversational assistance and hosting
        infrastructure. Those providers handle limited information under
        their own privacy policies. We select providers with
        privacy-respecting practices.
      </LegalSection>

      <LegalSection heading="9. Children's Privacy">
        FiguMatch is not directed to children under the age required by
        applicable law in your jurisdiction. We do not knowingly collect
        personal information from children below that age. If you
        believe a child has provided us information, please contact us
        so we can delete it.
      </LegalSection>

      <LegalSection heading="10. International Data Transfers">
        Your information may be processed in countries other than the
        one in which you reside. When we transfer data across borders,
        we use appropriate safeguards to ensure your information receives
        an adequate level of protection.
      </LegalSection>

      <LegalSection heading="11. Changes to This Policy">
        We may update this Privacy Policy from time to time. When we
        make material changes, we will notify you through the Service or
        by email. Your continued use of the Service after the effective
        date of the updated Policy constitutes your acceptance of the
        changes.
      </LegalSection>

      <LegalSection heading="12. Contact">
        If you have questions, requests, or complaints about this
        Privacy Policy, please contact us at hello@figumatch.com. We
        will do our best to resolve your concern promptly.
      </LegalSection>
    </LegalDocLayout>
  );
}
